import request from '../utils/request'

// 获取岗位列表（分页+模糊查询）
export function getStationList(data) {
  return request({
    url: '/station/page',
    method: 'post',
    data
  })
}

// 根据ID获取岗位详情
export function getStationById(id) {
  return request({
    url: `/station/${id}`,
    method: 'get'
  })
}

// 获取全部岗位
export function getAllStations() {
  return request({
    url: '/station/all',
    method: 'get'
  })
}

// 创建岗位
export function createStation(data) {
  return request({
    url: '/station',
    method: 'post',
    data
  })
}

// 更新岗位
export function updateStation(data) {
  return request({
    url: '/station',
    method: 'put',
    data
  })
}

// 删除岗位
export function deleteStation(id) {
  return request({
    url: `/station/${id}`,
    method: 'delete'
  })
}